
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Vant from 'vant'
import 'vant/lib/index.css'
import Message from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './util/rem'
import VueClipboard from 'vue-clipboard2'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Storage from 'vue-ls'
import '@/assets/iconfont.css'

Vue.prototype.$http = axios

Vue.use(Vant)
Vue.use(VueQuillEditor)
Vue.use(Message)
Vue.use(VueClipboard)
window.sysTomName = 'c32711980e0e11f0a41b023222ea4923'

let options = {
  namespace: 'ost__', // key键前缀
  name: 'ls', // 命名Vue变量.[ls]或this.[$ls],
  storage: 'local' // 存储名称: session, local, memory
}
Vue.use(Storage)
// Toast.setDefaultOptions('loading', { forbidClick: true , overlay :true});

// router.beforeEach((to,from,next) => {
//   console.log(to.query.channelNo, '-----------------------')
//   if (to.path == '/' || to.path == '/land' || to.path == '/land2'|| to.path == '/land3'|| to.path == '/land5'|| to.path == '/land6') {
//     if (to.query.channelNo) {
//       next(`/land4?channelNo=${to.query.channelNo}`)
//     } else {
//       next('/land4')
//     }
//   } else {
//     next()
//   }
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js